<template>
  <div>
    <div class="top-fade-in row mb-2">
      <input-field
        label="Name"
        label-position="top"
        class="px-1 col-12 col-sm-6 col-md-4"
      >
        <div class="text-left overflow-hidden">
          {{ healthcheck.name || '-' }}
        </div>
      </input-field>
      <input-field
        label="Request URL"
        label-position="top"
        class="px-1 col-12 col-sm-6 col-md-4"
      >
        <div class="text-left overflow-hidden">
          <a
            v-clipboard:copy="urlFormatted"
            v-clipboard:success="copySuccess"
            class="healthcheck-url"
          >
            <span class="p-0 m-0">
              {{ urlFormatted }}
            </span>
            <span class="copy-url">
              <GjIcon name="Copy" />
            </span>
          </a>
        </div>
      </input-field>
      <input-field
        label="Method"
        label-position="top"
        class="px-1 col-12 col-sm-6 col-md-4"
      >
        <b-badge
          :variant="
            changeMethodBadge(
              getText(healthcheck.methodOptions, healthcheck.method),
            )
          "
          class="m-0 text-sm"
        >
          {{ getText(healthcheck.methodOptions, healthcheck.method) || '-' }}
        </b-badge>
      </input-field>
      <input-field
        label="Status"
        label-position="top"
        class="px-1 col-12 col-sm-6 col-md-4"
      >
        <b-badge
          :variant="healthcheck.state ? 'light-primary' : 'light-warning'"
          class="text-sm"
        >
          {{ healthcheck.state ? 'Active' : 'Disabled' }}
        </b-badge>
      </input-field>
      <input-field
        label="Protocol"
        label-position="top"
        class="px-1 col-12 col-sm-6 col-md-4"
      >
        {{ healthcheck.protocol == 0 ? 'HTTPS' : 'HTTP' }}
      </input-field>
      <input-field
        label="Created At"
        label-position="top"
        class="px-1 col-12 col-sm-6 col-md-4"
      >
        {{ formatOffsetDateTime(healthcheck.insertDate) }}
      </input-field>
    </div>
    <div class="text-left mb-3">
      <h6 class="text-medium">
        Status Logs
      </h6>
      <status-log-list
        v-if="healthcheck.healthcheckLogStatuses"
        :logs="healthcheck.healthcheckLogStatuses"
        format-time
      />
      <span v-else>
        -
      </span>
    </div>
    <b-tabs
      content-class="pt-1"
      fill
    >
      <b-tab
        active
        title="Headers"
      >
        <form-headers
          :healthcheck="healthcheck"
          :headers="headers"
          :editable="false"
          @pushHeaders="overwriteHeaders"
        />
      </b-tab>
      <b-tab title="Request Body">
        <form-body-editor
          :request-method="healthcheck.method"
          :body-value="healthcheck.body"
          :editable="false"
          :content-type="contentType"
          editor-id="request-body"
          :request-body-form="true"
        />
      </b-tab>
      <b-tab
        v-if="healthcheck.expectedBody"
        title="Expected Body"
      >
        <form-body-editor
          :body-value="healthcheck.expectedBody"
          :editable="false"
          :content-type="contentType"
          editor-id="expected-body"
          editor-title="Expected Response:"
        />
      </b-tab>
      <b-tab title="Settings">
        <request-settings
          :healthcheck="healthcheck"
          :state="healthcheckInitialState || false"
          :editable="false"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import FormHeaders from '../../components/FormHeaders.vue'
import FormBodyEditor from '../../components/FormBodyEditor.vue'
import RequestSettings from '../../components/RequestSettings.vue'
import StatusLogList from '../../components/StatusLogList.vue'

export default {
  components: {
    FormHeaders,
    FormBodyEditor,
    RequestSettings,
    StatusLogList,
  },
  data() {
    return {
      healthcheckInitialState: false,
      id: null,
      hasHealthcheckPermissions: true,
      headers: [],
      contentType: 'json',
    }
  },
  computed: {
    urlFormatted() {
      return this.healthcheck.protocol === 0
        ? `https://${this.healthcheck.url || '-'}`
        : `http://${this.healthcheck.url || '-'}`
    },
    healthcheck() {
      return this.$store.state.healthchecks.healthcheck
    },
  },
  watch: {
    headers() {
      const index = this.headers.map(e => e.key?.toLowerCase()).lastIndexOf('content-type')
      this.contentType = this.headers[index]?.value || 'json'
    },
  },
  created() {
    this.healthcheckInitialState = this.healthcheck.state
  },
  methods: {
    overwriteHeaders(headers) {
      this.headers.push(headers)
    },
    formatString(value) {
      if (typeof value === 'object') {
        const temp = JSON.stringify(value)
        return temp
      }
      return value
    },
    changeMethodBadge(method) {
      if (method === 'GET') {
        return 'light-success'
      }
      if (method === 'DELETE') {
        return 'light-danger'
      }
      if (method === 'POST') {
        return 'light-warning'
      }
      if (method === 'PUT') {
        return 'light-primary'
      }
      return 'light-secondary'
    },
    copyUrl() {
      this.infoToast('Copied to clipboard!')
    },
  },
}
</script>

<style lang="scss" scoped>
.card-info::v-deep {
  .card-header {
    padding: 16px 0;
  }
  .card-body {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 14px;
  }
}
.healthcheck-url {
  color: #1d79f2;
  &:hover {
    color: #0d6ce8;
  }
}
.copy-url {
  cursor: pointer;
}
</style>
